import { fileOpen as t } from "browser-fs-access";

function n(t, n) {
  for (var r = 0; r < n.length; r++) {
    var e = n[r];
    e.enumerable = e.enumerable || !1, e.configurable = !0, "value" in e && (e.writable = !0), Object.defineProperty(t, e.key, e);
  }
}

function r(t, r, e) {
  return r && n(t.prototype, r), e && n(t, e), t;
}

function e(t, n) {
  t.prototype = Object.create(n.prototype), t.prototype.constructor = t, o(t, n);
}

function o(t, n) {
  return (o = Object.setPrototypeOf || function (t, n) {
    return t.__proto__ = n, t;
  })(t, n);
}

function a() {
  var t = (self.getSelection() || {}).anchorNode;
  if (t) return t.parentElement;
}

var i = function () {
  function t() {
    this.tags = void 0, this.keys = void 0, this.command = void 0, this.inputs = void 0;
  }

  var n = t.prototype;
  return n.getActive = function () {
    var t = this.command,
        n = this.tags;

    if (n) {
      var r = a();
      return !!r && r.matches(n.map(function (t) {
        return t + ", " + t + " *";
      }).join(", "));
    }

    return !!t && document.queryCommandState(t);
  }, n.edit = function (t) {
    var n;
    t.focus(), (n = document).execCommand.apply(n, [this.command, null].concat([].slice.call(arguments, 1)));
  }, n.execute = function (t) {
    var n = this.inputs,
        r = [];

    if (n) {
      var e = n.map(function (t) {
        return self.prompt(t);
      });
      if (!e.filter(Boolean)[0]) return;
      r = e;
    }

    this.edit.apply(this, [t].concat(r));
  }, r(t, [{
    key: "usable",
    get: function get() {
      var t = this.command;
      return !t || document.queryCommandSupported(t) || document.queryCommandEnabled(t);
    }
  }, {
    key: "active",
    get: function get() {
      return this.getActive();
    }
  }, {
    key: "title",
    get: function get() {
      var t = this.keys;
      return this.name + (this.usable ? t ? "\n(" + t.join(" + ") + ")" : "" : "\n(not supported)");
    }
  }]), t;
}(),
    c = function (n) {
  function r() {
    return n.apply(this, arguments) || this;
  }

  e(r, n);
  var o = r.prototype;
  return o.save = function (t) {
    try {
      return Promise.resolve(URL.createObjectURL(t));
    } catch (t) {
      return Promise.reject(t);
    }
  }, o.codeOf = function (t) {
    return t;
  }, o.execute = function (n) {
    try {
      var r = this,
          e = function e(t) {
        return a ? Promise.resolve(i.call(r, t)).then(o) : t;
      },
          o = function o(t) {
        t && r.edit(n, r.codeOf(t));
      },
          a = self.confirm("Confirm to upload a file, or cancel to input a path."),
          i = a && r.save;

      return Promise.resolve(a ? Promise.resolve(t()).then(e) : e(o(self.prompt("Path"))));
    } catch (t) {
      return Promise.reject(t);
    }
  }, r;
}(i),
    u = function (t) {
  function n() {
    for (var n, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (n = t.call.apply(t, [this].concat(e)) || this).name = "Bold", n.tags = ["b", "strong"], n.keys = ["Ctrl", "B"], n.command = "bold", n;
  }

  return e(n, t), n;
}(i),
    l = function (t) {
  function n() {
    for (var n, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (n = t.call.apply(t, [this].concat(e)) || this).name = "Italic", n.tags = ["i", "em"], n.keys = ["Ctrl", "I"], n.command = "italic", n;
  }

  return e(n, t), n;
}(i),
    s = function (t) {
  function n() {
    for (var n, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (n = t.call.apply(t, [this].concat(e)) || this).name = "Underline", n.tags = ["u"], n.keys = ["Ctrl", "U"], n.command = "underline", n;
  }

  return e(n, t), n;
}(i),
    f = function (t) {
  function n() {
    for (var n, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (n = t.call.apply(t, [this].concat(e)) || this).name = "Strike through", n.tags = ["s", "del", "strike"], n.command = "strikeThrough", n;
  }

  return e(n, t), n;
}(i),
    m = document.queryCommandSupported("heading") ? "heading" : "formatBlock",
    h = function (t) {
  function n() {
    for (var n, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (n = t.call.apply(t, [this].concat(e)) || this).name = "H1", n.tags = ["h1"], n.command = m, n;
  }

  return e(n, t), n.prototype.execute = function (t) {
    this.edit(t, "H1");
  }, n;
}(i),
    p = function (t) {
  function n() {
    for (var n, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (n = t.call.apply(t, [this].concat(e)) || this).name = "H2", n.tags = ["h2"], n.command = m, n;
  }

  return e(n, t), n.prototype.execute = function (t) {
    this.edit(t, "H2");
  }, n;
}(i),
    d = function (t) {
  function n() {
    for (var n, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (n = t.call.apply(t, [this].concat(e)) || this).name = "H3", n.tags = ["h3"], n.command = m, n;
  }

  return e(n, t), n.prototype.execute = function (t) {
    this.edit(t, "H3");
  }, n;
}(i),
    y = function (t) {
  function n() {
    for (var n, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (n = t.call.apply(t, [this].concat(e)) || this).name = "Font Size down", n.tags = ["small"], n.command = "decreaseFontSize", n;
  }

  return e(n, t), n;
}(i),
    g = function (t) {
  function n() {
    for (var n, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (n = t.call.apply(t, [this].concat(e)) || this).name = "Font Size up", n.tags = ["big"], n.command = "increaseFontSize", n;
  }

  return e(n, t), n;
}(i),
    v = function (t) {
  function n() {
    for (var n, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (n = t.call.apply(t, [this].concat(e)) || this).name = "Subscript", n.tags = ["sub"], n.command = "subscript", n;
  }

  return e(n, t), n;
}(i),
    A = function (t) {
  function n() {
    for (var n, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (n = t.call.apply(t, [this].concat(e)) || this).name = "Superscript", n.tags = ["sup"], n.command = "superscript", n;
  }

  return e(n, t), n;
}(i),
    w = function (t) {
  function n() {
    for (var n, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (n = t.call.apply(t, [this].concat(e)) || this).name = "Link", n.tags = ["a"], n.inputs = ["Path"], n.command = "createLink", n;
  }

  return e(n, t), n;
}(i),
    b = function (t) {
  function n() {
    return t.apply(this, arguments) || this;
  }

  e(n, t);
  var o = n.prototype;
  return o.getColor = function () {
    var t = a(),
        n = this.colorName;
    if (!t) return "color" === n ? "#000000" : "#ffffff";
    var r = getComputedStyle(t)[n].match(/\d+/g),
        e = r[1],
        o = r[2];
    return "#" + (+r[0]).toString(16).padStart(2, "0") + (+e).toString(16).padStart(2, "0") + (+o).toString(16).padStart(2, "0");
  }, o.execute = function (t, n) {
    this.edit(t, n);
  }, r(n, [{
    key: "active",
    get: function get() {
      return !!this.getColor();
    }
  }]), n;
}(i),
    C = function (t) {
  function n() {
    for (var n, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (n = t.call.apply(t, [this].concat(e)) || this).name = "Fore Color", n.command = "foreColor", n.colorName = "color", n;
  }

  return e(n, t), n;
}(b),
    k = function (t) {
  function n() {
    for (var n, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (n = t.call.apply(t, [this].concat(e)) || this).name = "Back Color", n.command = "backColor", n.colorName = "backgroundColor", n;
  }

  return e(n, t), n;
}(b),
    S = function (t) {
  function n() {
    return t.apply(this, arguments) || this;
  }

  return e(n, t), r(n, [{
    key: "active",
    get: function get() {
      if (t.prototype.getActive.call(this)) return !0;
      var n = a();
      return !!n && getComputedStyle(n).textAlign === this.align;
    }
  }]), n;
}(i),
    j = function (t) {
  function n() {
    for (var n, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (n = t.call.apply(t, [this].concat(e)) || this).name = "Align Left", n.command = "justifyLeft", n.align = "left", n;
  }

  return e(n, t), n;
}(S),
    x = function (t) {
  function n() {
    for (var n, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (n = t.call.apply(t, [this].concat(e)) || this).name = "Align Center", n.command = "justifyCenter", n.align = "center", n;
  }

  return e(n, t), n;
}(S),
    H = function (t) {
  function n() {
    for (var n, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (n = t.call.apply(t, [this].concat(e)) || this).name = "Align Right", n.command = "justifyRight", n.align = "right", n;
  }

  return e(n, t), n;
}(S),
    L = function (t) {
  function n() {
    for (var n, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (n = t.call.apply(t, [this].concat(e)) || this).name = "Align Full", n.command = "justifyFull", n.align = "justify", n;
  }

  return e(n, t), n;
}(S),
    O = function (t) {
  function n() {
    for (var n, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (n = t.call.apply(t, [this].concat(e)) || this).name = "Ordered list", n.tags = ["ol"], n.command = "insertOrderedList", n;
  }

  return e(n, t), n;
}(i),
    P = function (t) {
  function n() {
    for (var n, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (n = t.call.apply(t, [this].concat(e)) || this).name = "Unordered list", n.tags = ["ul"], n.command = "insertUnorderedList", n;
  }

  return e(n, t), n;
}(i),
    F = function (t) {
  function n() {
    for (var n, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (n = t.call.apply(t, [this].concat(e)) || this).name = "Horizontal rule", n.tags = ["hr"], n.command = "insertHorizontalRule", n;
  }

  return e(n, t), n;
}(i),
    R = function (t) {
  function n() {
    for (var n, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (n = t.call.apply(t, [this].concat(e)) || this).name = "Embed Web page", n.tags = ["iframe"], n.command = "insertHTML", n;
  }

  return e(n, t), n.prototype.execute = function (t) {
    var n = self.prompt("Path");
    n && this.edit(t, '<iframe style="width: 100%; height: 50vh; border: none" src="' + n + '"></iframe>');
  }, n;
}(i),
    U = function (t) {
  function n() {
    for (var n, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (n = t.call.apply(t, [this].concat(e)) || this).name = "Image", n.tags = ["img"], n.command = "insertImage", n;
  }

  return e(n, t), n;
}(c),
    z = function (t) {
  function n() {
    for (var n, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (n = t.call.apply(t, [this].concat(e)) || this).name = "Audio", n.tags = ["audio"], n.command = "insertHTML", n;
  }

  return e(n, t), n.prototype.codeOf = function (t) {
    return '<audio controls src="' + t + '"></audio>';
  }, n;
}(c),
    B = function (t) {
  function n() {
    for (var n, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (n = t.call.apply(t, [this].concat(e)) || this).name = "Video", n.tags = ["video"], n.command = "insertHTML", n;
  }

  return e(n, t), n.prototype.codeOf = function (t) {
    return '<video controls src="' + t + '"></video>';
  }, n;
}(c),
    q = function (t) {
  function n() {
    for (var n, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (n = t.call.apply(t, [this].concat(e)) || this).name = "Undo", n.command = "undo", n;
  }

  return e(n, t), n;
}(i),
    I = function (t) {
  function n() {
    for (var n, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (n = t.call.apply(t, [this].concat(e)) || this).name = "Redo", n.command = "redo", n;
  }

  return e(n, t), n;
}(i),
    N = function (t) {
  function n() {
    for (var n, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (n = t.call.apply(t, [this].concat(e)) || this).name = "Reset", n.command = "removeFormat", n;
  }

  return e(n, t), n;
}(i),
    T = function (t) {
  function n() {
    for (var n, r = arguments.length, e = new Array(r), o = 0; o < r; o++) {
      e[o] = arguments[o];
    }

    return (n = t.call.apply(t, [this].concat(e)) || this).name = "Clear", n;
  }

  return e(n, t), n.prototype.execute = function (t) {
    t.focus(), document.execCommand("selectAll"), document.execCommand("delete");
  }, n;
}(i);

export { x as AlignCenterTool, L as AlignFullTool, j as AlignLeftTool, H as AlignRightTool, S as AlignTool, z as AudioTool, k as BackColorTool, u as BoldTool, T as ClearTool, b as ColorTool, c as FileTool, y as FontSizeDownTool, g as FontSizeUpTool, C as ForeColorTool, h as H1Tool, p as H2Tool, d as H3Tool, F as HorizontalRuleTool, R as IFrameTool, U as ImageTool, l as ItalicTool, w as LinkTool, O as OrderedListTool, I as RedoTool, N as ResetTool, f as StrikeThroughTool, v as SubscriptTool, A as SuperscriptTool, i as Tool, s as UnderlineTool, q as UndoTool, P as UnorderedListTool, B as VideoTool, a as getAnchorElement };